import { useNavigate } from '@tanstack/react-router';
import { Avatar, Button, Flex, Typography } from 'antd';
import { SearchAlert } from 'lucide-react';
import { useEffect } from 'react';

import { hideHtmlLoader } from './ui/utils/html';

import type { NotFoundRouteProps } from '@tanstack/react-router';

export function NotFound(_props: NotFoundRouteProps) {
  const navigate = useNavigate();

  useEffect(() => {
    hideHtmlLoader();
  }, []);

  return (
    <Flex flex={1} vertical align="center" justify="center" style={{ padding: 24 }}>
      <Flex vertical align="center" gap={20} style={{ maxWidth: 420 }}>
        <Avatar
          size={56}
          icon={<SearchAlert />}
          style={{ backgroundColor: '#fde3cf', color: '#f56a00' }}
        />
        <Typography.Title level={3} style={{ margin: 0 }}>
          Page not found
        </Typography.Title>
        <Typography.Text type="secondary">
          This link may be broken or the page may have been removed.
        </Typography.Text>
        <Button type="primary" onClick={() => navigate({ to: '/' })}>
          Go home
        </Button>
      </Flex>
    </Flex>
  );
}
